import { useContext } from 'react'

import KanbanColumnStatesContext from 'contexts/KanbanColumnStatesContext'

const useKanbanColumnStates = () => {
  const context = useContext(KanbanColumnStatesContext)

  if (context === undefined) {
    throw new Error(
      'useKanbanColumnStates must be used within a KanbanColumnStatesProvider',
    )
  }

  return context
}

export default useKanbanColumnStates
